// Packages
import { Component } from "react";
// import axios from "axios";
import { Link } from "react-router-dom";

// Styles
import "./schoolAdmin.css";

// Material Ui
import MaterialTable from "material-table";
import { Button } from "@material-ui/core";
import userService from "../../services/user.service";
import SchoolAdminDashboard from "./schoolAdminDashboard";
import AddIcon from "@material-ui/icons/Add";
import menuthree from "../../assets/images/menuthree.png";
import {
  FaTimes,
  FaAmazon,
  FaPen,
  FaPowerOff,
  FaUserEdit,
  FaUserCog,
  FaRegEdit,
  FaUser,
  FaSchool,
  FaRegEnvelope,
  FaLock,
  FaKey,
  FaTrash,
  FaUsers,
} from "react-icons/fa";

//dialog
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import successimg from "../../assets/images/successimg.png";
import DialogContent from "@material-ui/core/DialogContent";
import close from "../../assets/images/crosstick.png";

//
import { getFromLocalStorage } from "../../utils/webStorage";

class Storage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
      atheleteSelectedData: [],
      cochesSelectedData: [],
      schoolId: null,
      total: null,
      submitting: false,
      selectedTeam: "",
      deleteIdForGroup: "",

      blure: true,
      if(blure) {
        blure.classList.add("spinstyle");
      },
    };
  }

  columns = [
    { title: "id", field: "id", hidden: true },
    {
      title: "NAME",
      field: "teamName",
      render: (row) => (
        <Link to={`/teamdetails/${row.id}`}>
          <div className="link-blue" key={row.id}>
            {row.teamName}
          </div>
        </Link>
      ),
    },

    // {title:'NAME', field:'teamName'},
    {
      title: "CREATED ON",
      field: "createdAt",
      type: "date",
      dateSetting: { locale: "en-US" },
    },
    {
      title: "COACHES",
      field: "coachCount",
      render: (row) => (
        <div
          className="link-blue cp pl-4"
          key={row.id}
          onClick={() => this.openDialog(row.teamCoaches, row.teamName)}
        >
          {row.coachCount}
        </div>
      ),
    },
    {
      title: "ATHLETES",
      field: "athleteCount",
      render: (row) => (
        <label className="btnfieldcenter">
          <div
            className="link-blue cp"
            key={row.id}
            onClick={() =>
              this.openDialogathelete(row.teamAthelets, row.teamName)
            }
          >
            {row.athleteCount}
          </div>
        </label>
      ),
    },
    {
      title: "MATCHES",
      field: "specialty",
    },

    {
      render: (rowData) => (
        <div class="dropdown" onClick={(event) => event.stopPropagation()}>
          <span className="cp three-dot pr-2">
            <img className="cp" src={menuthree} alt="menu"></img>{" "}
          </span>
          <div class="dropdown-content manage-dropdown-content">
            <div className="manage-section-dropdown-item cp">
              <FaUsers className="manage-section-iconss" />
              <Link
                className="manage-section-dropdown-item-link"
                to={`/editteams/${rowData.id}`}
              >
                <p className="manage-small-popup-menuu1-p">Edit Team Details</p>
              </Link>
            </div>

            {/* ))} */}
            {/* <label className="cp">Reset Password</label> */}
            <div
              className="manage-section-dropdown-item cp"
              onClick={(event) => {
                event.stopPropagation();
                this.openDeleteDialog(rowData.id);
              }}
            >
              <FaTrash className="manage-section-iconss delete-icon" />
              <div className="manage-section-dropdown-item-link">
                <p className="manage-small-popup-menuu1-p">Delete</p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  /**/

  //pop up
  openDialog(coaches, team) {
    var cochesSelectedData = coaches;
    var selectedTeam = team;
    this.setState({ cochesSelectedData });
    this.setState({ selectedTeam });
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }
  openDialogathelete(athelete, team) {
    var atheleteSelectedData = athelete;
    var selectedTeam = team;
    this.setState({ atheleteSelectedData });
    this.setState({ selectedTeam });
    this.setState({ openathelete: !this.state.openathelete });
  }
  closeDialogathelete() {
    this.setState({ openathelete: !this.state.openathelete });
  }

  openDeleteDialog = (deleteId) => {
    this.setState({
      openDeletePop: !this.state.openDeletePop,
      deleteIdForGroup: deleteId,
    });
  };

  closeDeleteDialog = () => {
    this.setState({ openDeletePop: !this.state.openDeletePop });
    // this.deleteCoach();
  };
  ConfirmDeleteDialog = () => {
    this.setState({ openDeletePop: !this.state.openDeletePop });
    this.deleteTeams();
  };

  deleteTeams() {
    if (this.state.deleteIdForGroup != "") {
      userService
        .deleteTeamsApi(this.state.deleteIdForGroup)
        .then((response) => {
          if (response.status === 200) {
            this.getSchoolData();
            this.state.deleteIdForGroup = "";
            this.openDialogRemoved();
          } else {
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }

  //
  componentDidMount() {
    const teamone = document.getElementById("Team");
    if (teamone) {
      teamone.classList.add("btnActive");
    }
    // var schoolId = getFromLocalStorage("schoolId");
    // this.setState({schoolId});
    this.getSchoolData();
    // this.openDialogathelete();
  }

  getSchoolData() {
    this.setState({
      submitting: true,
    });
    var schoolId = getFromLocalStorage("schoolId");
    userService
      .getAllTeams(schoolId)
      .then((response) => {
        if (response.data.status == true) {
          this.setState({
            submitting: false,
          });
          var allSchoolList = response.data.data.teams;
          this.setState({ allSchoolList });
          var total = response.data.data.total;
          this.setState({ total });
        }
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
      });
  }

  openDialogRemoved() {
    this.setState({ openSuccessTeam: !this.state.openSuccessTeam });
  }
  closeDialogRemoved() {
    this.setState({ openSuccessTeam: !this.state.openSuccessTeam });
  }

  render() {
    const {
      imageUploadText,
      submitting,
      allSchoolList,
      cochesSelectedData,
      atheleteSelectedData,
      selectedTeam,
    } = this.state;
    return (
      <div className={this.state.submitting ? "gray-out" : ""}>
        <div className="content-layout p-0">
          <SchoolAdminDashboard />
          <div className="mng-header">
            <h4 className="fs-24 black bold mob-hd">
              Teams ({this.state.total != null ? this.state.total : "0"})
            </h4>
            <Link to="/createteam">
              <Button className="addBtnn" startIcon={<AddIcon />}>
                Create Team
              </Button>
            </Link>
          </div>
          {/* for coaches count*/}

          {/* cancel pop up */}
          <Dialog
            id="dialogBox"
            open={this.state.open}
            onClose={this.closeDialog.bind(this)}
          >
            <DialogTitle>
              <div className="row">
                <div className="col-10 col-lg-10 col-md-10">
                  <label>
                    <div className="link-blue cp">{selectedTeam} | Coaches</div>
                  </label>
                </div>
                <div className="col-1 text-right ml-auto ">
                  <FaTimes
                    onClick={this.closeDialog.bind(this)}
                    className="crossview cp"
                  />
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="clear10"></div>
              <div className="row">
                <p className="coach-list fs-22 black medium">List Of Coaches</p>
              </div>
              <div className="row d-block">
                {cochesSelectedData &&
                  cochesSelectedData.map((item, index) => (
                    // <ul className="fs-20 regular black">
                    //   <li>{item.name}</li>
                    // </ul>
                    <p className="fs-20 regular black ">{item.name}</p>
                  ))}
              </div>
              <div className="clear10"></div>

              <div className="clear10"></div>
            </DialogContent>
          </Dialog>
          {/* end pops up */}

          {/* for athlete count */}

          {/* cancel pop up */}
          <Dialog
            id="dialogBox"
            open={this.state.openathelete}
            onClose={this.closeDialogathelete.bind(this)}
          >
            <DialogTitle>
              <div className="row">
                <div className="col-10 col-lg-10 col-md-10">
                  <label>
                    <div className="link-blue cp">
                      {selectedTeam} | Athelete
                    </div>
                  </label>
                </div>
                <div className="col-1 text-right ml-auto ">
                  <FaTimes
                    onClick={this.closeDialogathelete.bind(this)}
                    className="crossview cp"
                  />
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="clear10"></div>
              <div className="row">
                <p className="coach-list fs-22 black medium">
                  List Of Athletes
                </p>
              </div>
              <div className="row d-block">
                {atheleteSelectedData &&
                  atheleteSelectedData.map((item, index) => (
                    <p className="fs-20 regular black">{item.name}</p>
                  ))}
              </div>
              <div className="clear10"></div>

              <div className="clear10"></div>
            </DialogContent>
          </Dialog>
          {/* end pops up */}

          {/* end */}
          {/* <div className="clear20"></div> */}

          <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr">
            {allSchoolList && (
              <MaterialTable
                style={{ marginBottom: "20px" }}
                title=""
                data={allSchoolList}
                columns={this.columns}
                options={{
                  headerStyle: {
                    fontFamily: "Rajdhani-Bold",
                    fontSize: 14,
                    backgroundColor: "#F0F8FF",
                  },
                  rowStyle: { fontSize: 17, fontFamily: "Rajdhani-SemiBold" },
                  pageSize: 10,
                }}
              />
            )}
          </div>
          <Dialog
            id="dialogBox"
            open={this.state.openDeletePop}
            onClose={this.closeDeleteDialog}
          >
            <DialogTitle>
              <div className="row">
                <div className="col-1 text-right ml-auto">
                  <FaTimes
                    onClick={() => this.closeDeleteDialog()}
                    className="crossview cp"
                  />
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="clear10"></div>
              <div className="row">
                <div className="col-12 text-center">
                  <p className="fs-20 semi-bold text-center mb-4">
                    Are you sure
                    <br />
                    you want to remove the team?
                  </p>
                </div>
                <div className="col-5 col-md-3 col-lg-3 ml-auto text-center">
                  <button
                    type="button"
                    class="cancelbtn canBtn"
                    onClick={() => this.closeDeleteDialog()}
                  >
                    No
                  </button>
                </div>
                <div className="col-5 col-md-3 col-lg-3 mr-auto text-center ">
                  <button
                    type="button"
                    class="yes-btn delBtn"
                    onClick={() => this.ConfirmDeleteDialog()}
                  >
                    Yes, Remove
                  </button>
                  {/* </Link> */}
                </div>
              </div>
              <div className="clear10"></div>
              <div className="clear10"></div>
            </DialogContent>
          </Dialog>

          <Dialog
            id="dialogBoxRemove"
            open={this.state.openSuccessTeam}
            onClose={this.closeDialogRemoved.bind(this)}
          >
            <DialogTitle>
              <div className="row">
                <div className="col-1 text-right ml-auto">
                  <FaTimes
                    onClick={this.closeDialogRemoved.bind(this)}
                    className="crossview cp"
                  />
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="clear10"></div>
              <div className="row">
                <div className="col-12 text-center">
                  <img
                    src={successimg}
                    alt="success"
                    className="successimg-new"
                  ></img>
                  <p className="fs-20 semi-bold text-center">
                    Team Removed Successfully!
                  </p>
                  <div className="clear10"></div>
                </div>
                <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                  <button
                    type="button"
                    class="donebtn canBtn"
                    onClick={this.closeDialogRemoved.bind(this)}
                  >
                    DONE
                  </button>
                </div>
              </div>

              <div className="clear10"></div>

              <div className="clear10"></div>
            </DialogContent>
          </Dialog>
          {/* end */}
        </div>
      </div>
    );
  }
}
export default Storage;
